import { Box, Divider } from '@mui/material'
import { Typography } from '@mui/material'
import { Stack } from '@mui/material'
import { DateField, NumberField } from '@refinedev/mui'
import CustomChip from '@/components/override/Chip'

export const ShowField = ({ title, value, chipStatus, chipType }: { title: string, value: string | string[] | number, chipStatus?: "positive" | "negative" | "neutral", chipType?: "status" | "tag" | "company" | "collection" | "date" }) => {

    return (
        <>
            <Stack direction="row" alignItems="center" padding="24px" gap="24px">
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing="8px"
                    width="144px"
                >
                    <Typography fontWeight="600">{title}</Typography>
                </Stack>
                {Array.isArray(value) ?
                    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {value.map((item) => (
                            <CustomChip key={item} label={item} status={chipStatus || "neutral"} type={(chipType || "tag") as "status" | "tag" | "company" | "collection"} size="small" />
                        ))}
                    </Box> :
                    (chipType === "date" ? <DateField value={value} format="DD MMM YYYY" /> : typeof value === "number" ? <NumberField options={{ currency: "INR", style: "currency" }} value={value} /> : <Typography>{String(value)}</Typography>)}
            </Stack>
            <Divider />
        </>
    )
}